export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px] py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer no-underline">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white whitespace-nowrap">
                夫妻影院
              </span>
            </a>
            <p className="text-sm text-white/50 leading-relaxed mb-5">
              夫妻影院专注于为夫妻和情侣提供精心筛选的浪漫电影推荐、二人世界电影资源，免费高清在线观看不缓冲。我们相信每一部好电影都是一次感情的升温，让温馨观影体验成为日常。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-share-forward-line text-sm text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#cards" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a>
              <a href="#updates" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新快讯</a>
              <a href="#ranking" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门榜单</a>
              <a href="#topics" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              <a href="#faq" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">内容分类</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">浪漫爱情片</span>
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">婚姻家庭剧</span>
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">情侣喜剧</span>
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">高分经典</span>
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">新片速递</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              感谢各位合作伙伴的支持与信任，我们将持续为观众带来优质的夫妻电影与情侣影院观影体验。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/35">
            &copy; {new Date().getFullYear()} 夫妻影院 - 夫妻电影与情侣影院精选，二人世界最新浪漫电影推荐免费高清在线观看
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/35 cursor-pointer hover:text-white/60 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-white/35 cursor-pointer hover:text-white/60 transition-colors whitespace-nowrap">使用条款</span>
          </div>
        </div>
      </div>
    </footer>
  );
}